import React, { useCallback, useEffect, useState } from 'react';
import styles from './Onboarding.module.scss';
import VideoService from '../../service/VideoService';
import Nav from '../../../userservice/common/component/Nav/Nav';
import MainContainer from '../../../userservice/common/component/MainContainer';
import CmsAPI from '../../../common/apis/CmsAPI';
import ExtensionsComponent from '../ExtensionsComponent/ExtensionsComponent';
import AppComponent from '../AppsComponent/AppComponent';
import { useUserContext } from '../../context/UserContext';
import cx from 'classnames';

const videoUrl = 'https://file-examples-com.github.io/uploads/2017/04/file_example_MP4_1280_10MG.mp4'; // TODO: replace with actual Vormats onboarding video

const extensionId = process.env.EXT_ID;
const extensionUrl = process.env.CHROME_EXT_URL;

export default function Onboarding({ setIsOnboardingShowing }) {
  const [loading, setLoading] = useState(true);

  const [step, setStep] = useState(1);
  const [chromeExtensionInstalled, setChromeExtensionInstalled] = useState(false);
  const [edgeExtensionInstalled, setEdgeExtensionInstalled] = useState(false);
  const { updateUserData } = useUserContext();

  useEffect(() => {
    const checkProgress = async () => {
      const extensionExists = document.getElementById(extensionId);
      const checkStep1 = !!extensionExists;

      // Step 1 checker
      if (checkStep1) {
        setChromeExtensionInstalled(true);
      }
      setLoading(false);
    };
    checkProgress();
  }, []);

  useEffect(() => {
    const listenerFunc = async event => {
      // We only accept messages from this window to itself [i.e. not from any iframes]
      if (event.source !== window) return;

      if (event.data.type && event.data.type === `${extensionId}-extension`) {
        if (event.data.message === 'USER_MADE_A_VIDEO') {
          const { result } = await VideoService.getVideos({
            searchTerm: '',
            page: 0,
            size: 1,
            sort: ['createdOn,desc'],
          });
          console.log('result?.length:', result?.length);
          const checkStep3 = result?.length > 0;
          if (checkStep3) setStep(3);
        }
      }
    };
    window.addEventListener('message', listenerFunc);
    return () => window.removeEventListener('message', listenerFunc);
  }, []);

  const handleExtensionInstalled = async () => {
    // Store onboarding finished in localStorage
    let vormatsUser = JSON.parse(localStorage.getItem('vormatsUserData'));
    vormatsUser.onboarded = 1;
    localStorage.setItem('vormatsUserData', JSON.stringify(vormatsUser));

    setStep(2);
  };

  const handleFinishOnboarding = async () => {
    setIsOnboardingShowing(false);

    // Store onboarding finished in database
    await CmsAPI.updateUser({ onboarded: 1 });
    await updateUserData();
    window?.Appcues?.track('finished_app_download');
  };

  /* if (loading) return <EmptyStateOnboarding />; */
  return (
    <>
      <Nav />
      <MainContainer className={cx('content-padding play-bg', styles.background)}>
        <div>
          <div>
            <div className={styles.onboarding}>
              {/*{loading && (*/}
              {/*    <div className={styles.loadingContainer}>*/}
              {/*      <Icon className={styles.icon} src="spinner_md" />*/}
              {/*    </div>*/}
              {/*)}*/}

              {step === 1 && (
                <ExtensionsComponent
                  disableNext={!chromeExtensionInstalled && !edgeExtensionInstalled}
                  handleNextStep={handleExtensionInstalled}
                  handleFinishOnboarding={handleFinishOnboarding}
                  loading={loading}
                  chromeExtensionInstalled={chromeExtensionInstalled}
                  edgeExtensionInstalled={edgeExtensionInstalled}
                />
              )}

              {step === 2 && <AppComponent handleNextStep={handleFinishOnboarding} loading={loading} />}
            </div>
          </div>
        </div>
      </MainContainer>
    </>
  );
}
